export const styles = {
    iframeBackdropContainer: {
        backgroundColor: 'black',
        zIndex: '10000',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
    },
    iframeContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        zIndex: '10000',
        left: '0%',
        top: '0%',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
    },
    iframeContainerBorder: {
        width: '100%',
        height: '100%',
    },
    registrationIframe: {
        width: '100%',
        height: '100%',
        borderWidth: '0px',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
    },
    closeButton: {
        cursor: 'pointer',
        width: '35px',
        height: '35px',
        position: 'absolute',
        borderRadius: '100%',
        paddingLeft: '9px',
        paddingTop: '8px',
        backgroundColor: 'white',
        top: '1%',
        right: '4%',
        backgroundColor: 'rgba(255,255,255,0.75)',
        opacity: ({ showCloseButton }) => (showCloseButton ? 1 : 0),
        transition: '0.5s ease-in-out',
        '& img': {
            position: 'relative',
            marginLeft: '7px',
            marginTop: '8px',
        },
    },
}
